<script setup>
import { useRoute, RouterView } from 'vue-router';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import AppSidebar from './components/Sidebar/AppSidebar.vue';

const router = useRouter();
const route = useRoute();

const isLoginPage = ref(false); // Definisci isLoginPage come variabile reactive

const handleRouteChange = () => {
  isLoginPage.value = route.path === '/login'; // Aggiorna isLoginPage in base alla route corrente
};

router.afterEach(handleRouteChange);
</script>

<template>
  <div class="screen">
    <RouterView />
    <AppSidebar v-if="!isLoginPage" /> 
  </div>
</template>

<style lang="scss">
@import "./assets/main.scss";
</style>